import catalog from './trackCatalog.json';

const publicUrl = process.env.PUBLIC_URL || '';

export const RADIO_TRACKS = catalog.tracks.map(({ id, title, file, gain, transitionBeforeEnd }) => ({
  id,
  title,
  src: `${publicUrl}/music/${file}`,
  gain,
  transitionBeforeEnd,
}));

export const RADIO_FADE_SECONDS = catalog.fadeSeconds;
export const RADIO_MASTER_GAIN = catalog.masterGain;
export const LAST_START_TRACK_KEY = 'suarte:art-games-radio:last-start-track';

export function chooseTrack(tracks, excludedId, random = Math.random) {
  const choices = tracks.filter(track => track.id !== excludedId);
  const pool = choices.length ? choices : tracks;
  return pool[Math.floor(random() * pool.length)] || null;
}
